import {
    Box,
    FormControl,
    FormControlLabel,
    IconButton,
    LinearProgress,
    Radio,
    RadioGroup,
    Theme,
    Typography,
} from "@mui/material";
import { Location } from 'history';
import { useHistory } from "react-router";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {
    useEffect,
    useState
} from "react";
import { useDispatch } from "react-redux";
import { getRMHierarchy } from "../../../redux-store/actions/userManagement";
import { GetRMHierarchyResponseBody } from "../../../redux-store/types/api-types";
import OrganizationChart from "./OrganizationChart";
import BreadCrum from "../../../lib/BreadCrum";


interface CurrentHierarchy {
    parentId: string | number | null;
    id: string | number;
    name: string;
    title: string;
}

export default function RMHierarchy({ location }: { location: Location<{ rmId: string }> }): JSX.Element {
    const { rmId: idForRm } = location.state || { rmId: '' };
    const history = useHistory();

    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false);
    const [activeOption, setActiveOption] = useState("entire")
    const [currentHierarchy, setCurrentHierarchy] = useState<CurrentHierarchy[]>([]);

    const getData = async (currentRmId: string, isEntire: boolean) => {
        try {
            setLoading(true)

            const payload = {
                node: currentRmId,
                isEntire
            }

            const { isSuccess, result = [], nodes = [] } = await (dispatch(getRMHierarchy(payload)) as unknown as Promise<GetRMHierarchyResponseBody>)

            if (isSuccess) {
                setCurrentHierarchy([
                    { id: "root", parentId: null, name: '', title: "" },
                    ...result.map(obj => {
                        if (obj.parentId === null) {
                            return { ...obj, parentId: "root", }
                        } else return obj
                    })
                ])
            } else if (!isSuccess) {
                setCurrentHierarchy([])
            }

        } catch (error) {
            console.log("Error: ", error)
            setCurrentHierarchy([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getData("", true)
    }, [])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "particular") {
            getData(idForRm, false)
        } else if (event.target.value === "entire") {
            getData("", true)
        }

        setActiveOption((event.target as HTMLInputElement).value);
    };

    const route = [
        {
            name: "Relationship Managers",
            path: "/user-management/relationship-managers"
        },
        {
            name: 'View Hierarchy',
            path: '/user-management/view-hierarchy'
        }
    ]
    return (
        <Box sx={{ backgroundColor: 'common.white', px: 4 }} >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    pt: { xs: 2, sm: 7 },
                    pb: 2,
                    flexDirection: { xs: 'column', sm: 'row' },
                }}>
                <BreadCrum array={route} />
                {/* <IconButton
                    sx={{
                        fontSize: 20,
                        paddingLeft: 0,
                        ':hover': {
                            textDecoration: 'underline',
                            backgroundColor: '#fff',
                        },
                    }}
                    onClick={() => history.push('relationship-managers')}>
                    Relationship Managers
                </IconButton>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <NavigateNextIcon fontSize="medium" />
                    <Typography
                        sx={{
                            fontSize: 20,
                            fontWeight: 600,
                            color: '#1C2D47',
                        }}>
                        View Hierarchy
                    </Typography>
                </Box> */}
            </Box>
            {loading && <LinearProgress />}
            {!loading && (
                <Box sx={{ mt: 2 }}>
                    <FormControl>
                        <RadioGroup
                            row
                            value={activeOption}
                            onChange={handleChange}
                        >
                            <FormControlLabel
                                value="particular"
                                control={<Radio />}
                                label={
                                    <Typography
                                        variant="body_500"
                                        sx={{ fontWeight: activeOption === "particular" ? 600 : 400 }}
                                    >
                                        Particular
                                    </Typography>
                                }
                            />
                            <FormControlLabel
                                value="entire"
                                control={<Radio />}
                                label={
                                    <Typography
                                        variant="body_500"
                                        sx={{ fontWeight: activeOption === "entire" ? 600 : 400 }}
                                    >
                                        Entire
                                    </Typography>
                                }
                            />
                        </RadioGroup>
                    </FormControl>
                    {currentHierarchy.length ? (
                        <OrganizationChart data={currentHierarchy} />
                    ) : (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "100px 0"
                            }}
                        >
                            <Typography
                                variant="body_600"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                No Hierarchy Found
                            </Typography>
                        </Box>
                    )}
                </Box>
            )
            }
        </Box >
    );
}